import config from '../../config';
//hostUrlResolver
export function get(){
  //let host = window.location.host.split(':')[0];
  //host = `http://${host}:3030`;

  
  let host = window.location.host;
  if(host.split('.').length > 1) {
    // host = `http://api-${host}`;
    host = '/api';
  }
  else {
    host = `${config.debugApiHost}`;
  }

  return host;
}

// export function getStorage(){
//   let host = window.location.host;
//   if(host.split('.').length > 1) {
//     let hostName = host.split('.')[0];
//     host = host.replace(hostName, 'storage');
//     host = `https://${host}/uploads/`;
//   }
//   else {
//     host = `${config.storageApi}`;
//   }
//   return host;
// }

export function getCldr(){
  const host = `${config.cldr}`;

  // let host = window.location.host;
  // if(host.split('.').length > 1) {
  //   let hostName = host.split('.')[0];
  //   host = host.replace(hostName, 'cldr');
  //   host = `https://${host}`;
  // }
  // else {
  //   host = `${config.cldr}`;
  // }
  return host;
}



// WEBPACK FOOTER //
// ./src/application/client/hostUrlResolver.js